export default __webpack_public_path__ + "static/media/s3.bd5c4a2a.jpg";